import {AfterViewInit, Component, OnInit} from '@angular/core';
import {CardAction} from "../../components/scotty-card/scotty-card.component";
import {Router} from "@angular/router";
import {FieldService, FieldServiceType} from "../../models/field-service";
import {FieldServiceManagerService} from "../../services/field-service-manager.service";
import {Paginator} from "../../models/paginator";

@Component({
  selector: 'app-field-service-page',
  templateUrl: './field-service-page.component.html',
  styleUrls: ['./field-service-page.component.scss']
})
export class FieldServicePageComponent implements OnInit, AfterViewInit {

  isLoading = true;

  fieldServices: FieldService[] = [];
  fieldServicesToShow = [];

  paginator: Paginator<FieldService>;

  constructor(
    public router: Router,
    private fieldServiceManagerService: FieldServiceManagerService,
  ) { }

  ngOnInit() {
    this.paginator = new Paginator<FieldService>();
  }

  async ngAfterViewInit(): Promise<void> {
    await this.fetchFieldServices();
  }

  async fetchFieldServices() {

    this.isLoading = true;

    this.paginator.onPageResults = (fieldServices: FieldService[]) => {
      this.fieldServices = fieldServices;
      this.fieldServicesToShow = this.fieldServices.map(fieldService => {
        return {
          uid: fieldService.id,
          icon: 'domain',
          name: fieldService.name,
          description: fieldService.description,
          address: fieldService.location && fieldService.location.address ? [fieldService.location.address] : [],
        };
      });
    }

    await this.fieldServiceManagerService.getFieldServices(FieldServiceType.PLANT, this.paginator);

    this.isLoading = false;

  }

  getActions(): CardAction[] {
    return [
      { icon: 'add', name: 'New plant', callback: () => { this.router.navigate(['field-service/create']) } },
    ];
  }

}
